import _extends from "@babel/runtime/helpers/esm/extends";
import { getRecurringEventOccurrencesForVisibleDays } from "./getRecurringEventOccurrencesForVisibleDays.mjs";
export function hasOccurrenceBefore(adapter, event, occurrenceStart) {
  const dayBefore = adapter.addDays(adapter.startOfDay(occurrenceStart), -1);
  return getRecurringEventOccurrencesForVisibleDays(event, event.dataTimezone.start.value, adapter.endOfDay(dayBefore), adapter, event.dataTimezone.timezone).length > 0;
}
export function hasRemainingOccurrence(adapter, event, exDates) {
  const rule = event.dataTimezone.rrule;
  if (rule.count == null && rule.until == null) {
    return true;
  }
  const seriesStart = event.dataTimezone.start.value;
  const rangeEnd = rule.until ?? adapter.addYears(seriesStart, (rule.count ?? 1) * (rule.interval ?? 1));
  const eventWithExDates = _extends({}, event, {
    dataTimezone: _extends({}, event.dataTimezone, {
      exDates
    })
  });
  return getRecurringEventOccurrencesForVisibleDays(eventWithExDates, seriesStart, adapter.endOfDay(rangeEnd), adapter, event.dataTimezone.timezone).length > 0;
}